import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { styled } from "@mui/styles";
import { Button, Grid, makeStyles } from "@material-ui/core";
import { Link, NavLink, useNavigate } from "react-router-dom";
//import SearchBar from "material-ui-search-bar";
//import useRequest from "../../hooks/use-request";
import { fetchJobs, getSingleStudent } from "../../redux/actions/job.action";
import { fetchAllUsers } from "../../redux/actions/user.action";
import Skeleton from "@mui/material/Skeleton";
import { Typography, CardMedia } from "@material-ui/core";
//import CoolerBoxIMG from '../../assets/images/save-money.png';

import { notifyErrorFxn, notifySuccessFxn } from "src/utils/toast-fxn";

import { useDispatch, useSelector } from "react-redux";

import { deleteSingleJob } from "../../redux/actions/job.action";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#20dbe4",
    color: theme.palette.common.white,
    width: "24%",
    textAlign: "left",
    padding: "8px 16px",
    //  border: '1px solid #ddd',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    width: "24%",
    textAlign: "left",
    padding: "8px 16px",
    //  border: '1px solid #ddd',
  },
}));

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const originalJobList = [
  { id: 1, title: "Java Developer", fulldate: "01/01/2022" },
  { id: 2, title: "MERN Stack Developer", fulldate: "01/01/2022" },
  { id: 3, title: "Flutter Developer", fulldate: "01/01/2022" },
].sort((a, b) => (a.title < b.title ? -1 : 1));

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function CJobList({ jobs }) {
  //search function
  const dispatch = useDispatch();
  const [jobList, setJobList] = useState(jobs);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  // Get users from Redux and current user for companyID filtering
  const { allUsers, isLoading } = useSelector((state) => state.user || { allUsers: [], isLoading: false });
  const { user } = useSelector((state) => state.auth || {});

  useEffect(() => {
    console.log("Current user from Redux:", user);
    const fetchData = async () => {
      try {
        const res = await dispatch(fetchAllUsers());
        if (res && res.payload) {
          setUsers(res.payload);
        }
      } catch (err) {
        // Optionally handle error
      }
    };
    fetchData();
  }, [dispatch]);

  const [searched, setSearched] = useState("");
  const classes = useStyles();
  const requestSearch = (searchedVal) => {
    const filteredRows = jobs?.filter((row) => {
      return row.title.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setJobList(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - jobList.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const viewStudentFxn = (id) => {
    setLoading(true);
    dispatch(getSingleStudent(id));

    setTimeout(() => {
      navigate(`/dashboard/student-stats/`, { state: { id: id } });
    }, 2500);
  };

  const deleteJobFxn = (id) => {
    const preserveId = id;

    if (window.confirm("are you sure you want to delete this user?")) {
      //dispatch(deleteSingleJob(id));

      notifySuccessFxn("Employee Successfully Deleted!");

      setTimeout(function () {
        window.location.reload();
      }, 3000);
    }
  };

  return (
    <>
      {jobs ? (
        <>
          <br />
          <p
            style={{
              fontSize: "26px",
              marginLeft: "5px",
              marginBottom: "1rem",
              color: "black",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <b>ALL USERS</b>

            <Button
              type="button"
              variant="contained"
              style={{
                background: "#20dbe4",
                color: "white",
                width: "17%",
                fontSize: "15px",
              }}
              sx={{ mt: 7, mb: 2 }}
              onClick={() => navigate("/dashboard/users/create")}
            >
              Add User
            </Button>
          </p>
          <br />
          <hr />
          <TableContainer component={Paper}>
            <Table
              sx={{ width: "100%", tableLayout: "fixed" }}
              aria-label="custom pagination table"
            >
              <TableHead>
                <TableRow style={{ backgroundColor: "#20dbe4" }}>
                  <StyledTableCell align="left" >
                    Name
                  </StyledTableCell>
                  <StyledTableCell align="left"   sx={{
    display: { xs: "none", sm: "table-cell" }
  }} >
                    Email
                  </StyledTableCell>
                  <StyledTableCell  align="left">
                    Date
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    
                  </StyledTableCell>
                  {/*<StyledTableCell align="right">Industry</StyledTableCell>
              <StyledTableCell align="center">State</StyledTableCell>*/}
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? jobs.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : jobs
                ).map((job) => (
                  <TableRow key={job.id || Math.random()}>
                    <StyledTableCell >
                      {job.fullName ||
                        (job.firstName &&
                          job.lastName &&
                          `${job.firstName} ${job.lastName}`) ||
                        job.displayName ||
                        job.name ||
                        job.username ||
                        job.title ||
                        job.email ||
                        "-"}
                    </StyledTableCell>
                    <StyledTableCell   sx={{
    display: { xs: "none", sm: "table-cell" }
  }} >
                      {job.email || "-"}
                    </StyledTableCell>
                    <StyledTableCell  >
                      {job.registeredOn && typeof job.registeredOn !== "string"
                        ? new Date(
                            job.registeredOn.seconds * 1000
                          ).toDateString()
                        : (job.accountCreated &&
                          typeof job.accountCreated !== "string"
                            ? new Date(
                                job.accountCreated.seconds * 1000
                              ).toDateString()
                            : typeof job.accountCreated === "string" &&
                              job.accountCreated) ||
                          job.fulldate ||
                          "-"}
                    </StyledTableCell>
                    <StyledTableCell sx={{ width: '100%' }}>
                      <Button
                         type="button"
                          variant="contained"
                          style={{
                            background: "#20dbe4",
                            color: "white",
                            minWidth: "70%",
                            fontSize: "15px",
                          }}
                      >
                        View
                      </Button>
                    </StyledTableCell>
                  </TableRow>
                ))}

                {/*emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )*/}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "All", value: -1 },
                    ]}
                    colSpan={3}
                    count={jobList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </>
      ) : (
        <center>
          <Box sx={{ width: 300 }}>
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton animation={false} />
          </Box>
        </center>
      )}
  </>
  );
}
